<template>
  <div class="card">
    <div class="card-header d-flex justify-content-between">
      <h5 class="text-uppercase mb-0">Options du transport <small class="text-lowercase text-muted fs-6">( Business/Premium ect.. )</small></h5>
      <button class="btn btn-link link-dark p-0 link-underline-opacity-0 link-underline-opacity-100-hover" @click="addOption()"><i class="fa-solid fa-plus pe-1"></i>Ajouter une option</button>
    </div>
    <div class="card-body">
      <div v-if="options.length === 0" class="text-muted">
        Aucune option de transport
      </div>
      <div v-else v-draggable="[options,{ handle: '.sortIcon', animation: 150 }]" @end="onOrderChange">
        <div v-for="(option, idx) in options" :key="option.key" class="mb-2">
          <div class="row">
            <span :id="`${props.valueKey}[${idx}]`" class="anchor"></span>
            <div class="col-12 col-md-5">
              <TextInputComponent
                :value-key="`${props.valueKey}[${idx}].name`"
                label="Nom"
                placeholder="Nom"
                :required="true"
                class="mb-3 mb-md-0"
              />
            </div>
            <div class="col-12 col-md-3">
              <NumberInputComponent
                :value-key="`${props.valueKey}[${idx}].price`"
                label="Prix"
                placeholder="Prix"
                :required="true"
                type="euro"
                class="mb-3 mb-md-0"
              />
            </div>
            <div class="col-12 col-md-3">
              <NumberInputComponent
                :value-key="`${props.valueKey}[${idx}].quota`"
                label="Quota"
                placeholder="Quota"
                :required="true"
                class="mb-3 mb-md-0"
              />
            </div>
            <div class="col-12 col-md-1 d-flex justify-content-end order-first order-md-last mb-3 mb-md-0">
              <button class="btn btn-link link-secondary me-2"><i style="cursor: move;" class="sortIcon fa-solid fa-bars"></i></button>
              <button class="btn btn-link link-secondary p-0" @click="removeOption(idx)"><i class="fa-regular fa-trash-can fa-lg"></i></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { onMounted } from 'vue';
import { useFieldArray } from 'vee-validate';
import {IdNotDefined } from '@/compositions/helper'
import TextInputComponent from '@/components/common/TextInputComponent.vue';

import * as zod from 'zod';
import type { DraggableEvent } from 'vue-draggable-plus';

const props = defineProps<{
  valueKey: AllTypeKeys;
}>();

const validationSchema = defineModel<{ shape: zod.ZodRawShape, anchors?: Record<string, string | undefined> }>('validation-schema',{ required: false, default: () => ({ shape: {} }) });

const { remove: removeOption, push: pushOption, fields: options, move: moveOption } = useFieldArray<TravelDbTransportationOption>(() => props.valueKey);

const addOption = () => {
  pushOption(<TravelDbTransportationOption>{
    id: IdNotDefined,
    name: '',
    price: 0,
    quota: 0
  });
}

const onOrderChange = (event: DraggableEvent) => {
  if(event.oldIndex === undefined || event.newIndex === undefined) return;
  moveOption(event.oldIndex, event.newIndex);
}

onMounted(() => {
  validationSchema.value = {
    shape : {
      options: zod.array(zod.object({
          id: zod.number().nonnegative(),
          rank: zod.number().nonnegative().optional(),
          name: zod.string().min(1, 'Le nom de l\'option est obligatoire'),
          price: zod.number({ message: 'Prix de l\'option non valide' }).min(0, 'Le prix de l\'option doit être au minimum 0'),
          quota: zod.number({ message: 'Quota de l\'option non valide' }).min(0, 'Le quota de l\'option doit être au minimum 0')
        })).optional()
    },
    anchors: {
      [`${props.valueKey}[\\d].id`]: "self",
      [`${props.valueKey}[\\d].name`]: "self",
      [`${props.valueKey}[\\d].price`]: "self",
      [`${props.valueKey}[\\d].quota`]: "self"
    }
  }
});
</script>
